import { clamp } from 'lodash';
import {
  SET_SELECTED_FROM,
  SET_SELECTED_TO,
  SET_SELECTED_ROUTE,
  SET_SELECTED_DATE_TIME,
  SWAP_SELECTED_POINT,
  SET_SAFETY_MARGIN,
} from '../actions/constants';

export const defaultState = {
  selectedFrom: {
    id: 'Werkendam',
    branch: 'RH_WA',
    waterway: 'Waal',
    name: 'Werkendam',
    reduction: 0.26,
    target: 2.8,
    distance_start: 961,
    distance_end: 962,
    reference: 'NAP',
    pnp: null,
    glw: null,
    olr: 0.26,
    mark_one: null,
    mark_two: null,
    location: {
      type: 'Point',
      coordinates: [4.884343697, 51.81650087],
    },
    polygon: null,
    pegel_id: 'Werkendam m+NAP_km961',
    info_url: null,
    image_url: null,
    is_selectable: true,
    is_pseudo: false,
  },
  selectedTo: {
    id: 'Maxau',
    branch: 'RH_WA',
    waterway: 'Rhein',
    name: 'Maxau',
    reduction: 3.69,
    target: 2.1,
    distance_start: 334,
    distance_end: 384,
    reference: 'PNP',
    pnp: 97.721,
    glw: 3.69,
    olr: null,
    mark_one: 6.2,
    mark_two: 7.5,
    location: {
      type: 'Point',
      coordinates: [8.3149943, 49.0586099],
    },
    polygon: {
      type: 'Polygon',
      coordinates: [
        [
          [8.115027030484143, 48.83554389770157],
          [8.11407506827317, 48.83565925834415],
          [8.114073237945275, 48.835659656876814],
          [8.114071514055338, 48.83566038976969],
          [8.114069957093424, 48.8356614313061],
          [8.11406862169221, 48.83566274493926],
          [8.114067554709974, 48.83566428457474],
          [8.114066793586359, 48.835665996187814],
          [8.114066365028647, 48.83566781971922],
          [8.11406628407462, 48.83566969118253],
          [8.114272975549182, 48.83975360104783],
          [8.114273056092008, 48.839754124158866],
          [8.114273209831834, 48.83975530471629],
          [8.115166050146998, 48.84369703755427],
          [8.115254803239138, 48.84766622566304],
          [8.115147449044384, 48.8517498398507],
          [8.115147463523297, 48.85175002990129],
          [8.115147446456245, 48.851750234224646],
          [8.11514755240818, 48.85175119660667],
          [8.115147604227685, 48.85175187679089],
          [8.11514764154163, 48.85175200622314],
          [8.115147657319735, 48.85175214953872],
          [8.116000104076253, 48.8558285704464],
          [8.116000116948692, 48.85582861184164],
          [8.116000121525639, 48.85582865218343],
          [8.116000284043281, 48.85582914918504],
          [8.11600066941748, 48.85583038847282],
          [8.11600072034507, 48.85583048345673],
          [8.116000751571843, 48.85583057895255],
          [8.117742449149963, 48.859756328949125],
          [8.11774276113762, 48.85975688057857],
          [8.117743052255548, 48.85975748010749],
          [8.120042870007815, 48.863528705267235],
          [8.120042911966834, 48.86352876033284],
          [8.12004294583224, 48.86352882761398],
          [8.122402944279843, 48.86727630682564],
          [8.124371087153142, 48.87110981130985],
          [8.125709248992285, 48.87510631219034],
          [8.125709790636975, 48.87510753688161],
          [8.125709963371145, 48.87510794534119],
          [8.127809508284338, 48.87893662952393],
          [8.12781057766949, 48.87893820319166],
          [8.127810591390888, 48.878938216857684],
          [8.12781060172607, 48.87893823210147],
          [8.130797762088898, 48.88251433043133],
          [8.13079782604105, 48.88251439353007],
          [8.130797875476151, 48.88251446378393],
          [8.133858192430658, 48.88605046140065],
          [8.13659071515861, 48.88967527168777],
          [8.139092993713854, 48.893374573365804],
          [8.141012373240091, 48.89728417805404],
          [8.141012503043235, 48.897284385143486],
          [8.141012609681962, 48.897284630134266],
          [8.141013119046352, 48.897285367922024],
          [8.14101347083086, 48.89728592916312],
          [8.141013596680304, 48.897286059749895],
          [8.141013708500827, 48.897286221716094],
          [8.1440082076185, 48.900833463433706],
          [8.144008636466118, 48.90083387788593],
          [8.14400916345536, 48.90083444951808],
          [8.14767523487679, 48.90413018776314],
          [8.151127950302705, 48.907488753266826],
          [8.153715101681348, 48.91119822637069],
          [8.15371532381209, 48.911198486905],
          [8.15371549389727, 48.911198751210456],
          [8.156601415637066, 48.91480763443148],
          [8.156601585062301, 48.91480780981505],
          [8.15660172767592, 48.91480800580346],
          [8.156602228538365, 48.914808475920836],
          [8.156602714084933, 48.91480897854307],
          [8.156602916635835, 48.91480912177996],
          [8.156603096422451, 48.914809290530506],
          [8.16061574250395, 48.917921885222974],
          [8.160615848243333, 48.917921952815895],
          [8.160615938018934, 48.9179220330809],
          [8.16473741163643, 48.92096021040758],
          [8.168408470980989, 48.92420329577685],
          [8.171633897573727, 48.92766017662118],
          [8.174735044054493, 48.93114656314318],
          [8.174735063124228, 48.93114658050404],
          [8.174735080348652, 48.931146603723],
          [8.177833460864012, 48.93459192458497],
          [8.177833639673029, 48.93459208691219],
          [8.177833797064462, 48.9345922805071],
          [8.181166809109016, 48.93795209188566],
          [8.184505042058744, 48.941357999158996],
          [8.187153236251742, 48.94500639385414],
          [8.188986462905323, 48.948901050031196],
          [8.190840604046361, 48.95286522298712],
          [8.190840853592281, 48.95286563686648],
          [8.190841089294192, 48.95286613458995],
          [8.190841429863918, 48.95286659263017],
          [8.190841687265094, 48.952867019537706],
          [8.190841978258604, 48.95286733017908],
          [8.190842263313973, 48.95286771355675],
          [8.194153553720945, 48.956509575430836],
          [8.194153844669646, 48.95650984045997],
          [8.194154099683933, 48.95651013081832],
          [8.19415452985262, 48.95651046460249],
          [8.194154942869059, 48.95651084082479],
          [8.19415528704999, 48.95651105214058],
          [8.194155600257057, 48.9565112951698],
          [8.198921366348054, 48.959531061369326],
          [8.198921783449238, 48.95953127289218],
          [8.198922182306832, 48.95953152619231],
          [8.19892263599589, 48.95953170524075],
          [8.198923066416269, 48.959531923518114],
          [8.198923511373605, 48.959532050708674],
          [8.198923946235457, 48.959532222326956],
          [8.204874471286836, 48.96124929562444],
          [8.204875001173738, 48.961249395529364],
          [8.204875501550362, 48.96124953470345],
          [8.21089776506088, 48.96231502900267],
          [8.210897797933049, 48.96231503174752],
          [8.210897826021426, 48.962315039593776],
          [8.216858286176114, 48.963331606295355],
          [8.222782072226616, 48.96441300500473],
          [8.228653514184119, 48.96555763265011],
          [8.234305731922461, 48.9671068039084],
          [8.239035753125451, 48.96968109763873],
          [8.243373093073105, 48.97254916129677],
          [8.243373586913494, 48.972549417618474],
          [8.243374123927886, 48.972549757913434],
          [8.248263730108837, 48.97500324117598],
          [8.248264025078106, 48.975003355455286],
          [8.248264273572367, 48.9750034937805],
          [8.253443329524456, 48.977224535649356],
          [8.258470110051553, 48.97956839731023],
          [8.262984258345698, 48.982327051587234],
          [8.267260660568931, 48.985278815148334],
          [8.267261107766009, 48.98527906670589],
          [8.267261479085116, 48.98527932370809],
          [8.271935514054954, 48.98787998004725],
          [8.271935915765797, 48.987880154864456],
          [8.271936259755398, 48.987880355092884],
          [8.276994442769315, 48.99016505173278],
          [8.281578525838235, 48.992848439997424],
          [8.284890360071616, 48.99623712630481],
          [8.28733287752075, 48.9999187654602],
          [8.287332988023994, 48.999918901915045],
          [8.287333067082482, 48.99991904106908],
          [8.289908011869995, 49.00353188265663],
          [8.289908280064159, 49.003532186343925],
          [8.28990853262773, 49.003532551426375],
          [8.2928921096091, 49.00704617011877],
          [8.295896028936815, 49.010605744267686],
          [8.297740811353627, 49.01446268523472],
          [8.29921053008632, 49.018390080753],
          [8.299959651507466, 49.02240641810699],
          [8.300367406403401, 49.02643365723759],
          [8.300545970678492, 49.0304899721537],
          [8.300546021742917, 49.03049032421405],
          [8.300546026645497, 49.03049067627983],
          [8.301016165717272, 49.03457361671183],
          [8.301016338735979, 49.03457442001597],
          [8.301016493354142, 49.034575249652065],
          [8.302180854574301, 49.038603439539045],
          [8.30218099412159, 49.03860378546702],
          [8.30218109345156, 49.038604161757895],
          [8.303668137363374, 49.04258532972034],
          [8.303668374356832, 49.0425858121144],
          [8.303668606014204, 49.04258639182865],
          [8.305658945054304, 49.04646968697353],
          [8.305659138579685, 49.04646999082072],
          [8.305659290659468, 49.046470306153864],
          [8.307960715955577, 49.05027031986329],
          [8.307961068709918, 49.05027078310079],
          [8.307961441313765, 49.05027136194756],
          [8.310842369622097, 49.053895751821685],
          [8.31084259647708, 49.05389598556146],
          [8.310842783646617, 49.053896239783754],
          [8.314009302605758, 49.057394867969876],
          [8.316749665446865, 49.06102520357757],
          [8.31927263762506, 49.064779728830196],
          [8.319273105292691, 49.064780295061844],
          [8.319273626855361, 49.064780974182135],
          [8.322532589508615, 49.06827303088094],
          [8.322533033533244, 49.068273415902546],
          [8.322533507107226, 49.06827389738356],
          [8.326399180954944, 49.07148798100038],
          [8.326399626353401, 49.071488282239024],
          [8.326400008336007, 49.07148859952924],
          [8.330763475890217, 49.07441190763959],
          [8.330763969692558, 49.0744121748474],
          [8.330764416660912, 49.07441246588821],
          [8.335648665213979, 49.07696038077188],
          [8.339930746384097, 49.07986729352873],
          [8.343582895278562, 49.083128164584586],
          [8.346604188784765, 49.086674557886425],
          [8.346604678236886, 49.08667503356407],
          [8.346605086593783, 49.08667548352598],
          [8.350184703046526, 49.089918736660515],
          [8.35018494192927, 49.089918914657304],
          [8.350185134265786, 49.08991910562837],
          [8.354061878271315, 49.093050094486],
          [8.357234036267677, 49.09650718455349],
          [8.359358932179667, 49.10029825547456],
          [8.360838427540758, 49.10422124732796],
          [8.361667380130905, 49.10823170962151],
          [8.36230372668617, 49.112264105724435],
          [8.362303763611473, 49.11226424928327],
          [8.362303774698198, 49.112264384329585],
          [8.363055214249707, 49.11628444595242],
          [8.36305521911749, 49.1162844629922],
          [8.3630552204807, 49.11628447897967],
          [8.363820371549771, 49.12030306580977],
          [8.363820467851092, 49.120303398936215],
          [8.363820521415256, 49.12030372924335],
          [8.364865065906788, 49.12429154076525],
          [8.364865279581682, 49.12429211207629],
          [8.364865551570437, 49.124292954164666],
          [8.366548492054516, 49.12821031361863],
          [8.367939981772928, 49.1321586850727],
          [8.368449881173458, 49.136203874698694],
          [8.368680524172916, 49.14028084120967],
          [8.368680555084344, 49.14028103522802],
          [8.368680554948087, 49.14028124209985],
          [8.368680729578843, 49.140282130458324],
          [8.36868084296524, 49.14028284213818],
          [8.368680898286382, 49.14028298868499],
          [8.368680930019519, 49.1402831501136],
          [8.369872544138435, 49.144254829483245],
          [8.369872760643865, 49.144255355179695],
          [8.369872969968908, 49.144255984944095],
          [8.371590852347149, 49.14815818385895],
          [8.372554676037385, 49.15213144286055],
          [8.371480300835724, 49.1560811679917],
          [8.368642758437536, 49.159701371527724],
          [8.368642493360126, 49.15970179094915],
          [8.36864181867419, 49.15970280972931],
          [8.366508038206693, 49.16367663621637],
          [8.366507975613242, 49.163676787632355],
          [8.36650731565254, 49.16367834602216],
          [8.366507298346828, 49.16367842596607],
          [8.366507269472175, 49.16367849581498],
          [8.366507157636615, 49.163679075978365],
          [8.366506919732185, 49.163680174980364],
          [8.366506915709156, 49.16368033101259],
          [8.36650688859574, 49.16368047166742],
          [8.366506895679391, 49.16368110786235],
          [8.366506871499356, 49.16368204567933],
          [8.36679889853343, 49.16797465775249],
          [8.366798968778971, 49.16797506426557],
          [8.366798993458456, 49.16797551061694],
          [8.366799152552712, 49.16797612776981],
          [8.36679924930999, 49.16797668770712],
          [8.366799385339364, 49.16797703078763],
          [8.366799484574608, 49.16797741573752],
          [8.366799784819397, 49.16797803831867],
          [8.366800008597803, 49.16797860271156],
          [8.366800187831776, 49.167978873996496],
          [8.366800339182339, 49.16797918783377],
          [8.369189652078983, 49.17189483339311],
          [8.36919076608711, 49.171896326050856],
          [8.369190824265402, 49.17189637950744],
          [8.369190867587912, 49.17189643678554],
          [8.372450284336711, 49.17539919009019],
          [8.372450284354086, 49.17539919010563],
          [8.37245028436737, 49.17539919012313],
          [8.37567561779201, 49.178865284284015],
          [8.378444094419354, 49.18247781773512],
          [8.380798275613987, 49.18616916860597],
          [8.382091526326208, 49.19006070425077],
          [8.382626052881498, 49.19409177101855],
          [8.382626141375233, 49.194092151267334],
          [8.382626176610447, 49.194092497521034],
          [8.383462430864693, 49.198103498834186],
          [8.383462584405912, 49.198103999156075],
          [8.383462678674416, 49.19810445051033],
          [8.384703787320706, 49.202061516418404],
          [8.384703914373326, 49.20206181550009],
          [8.384703994390271, 49.20206211049603],
          [8.38620858264373, 49.205977824801046],
          [8.386827049750565, 49.209989216414954],
          [8.38606547337939, 49.21399572872028],
          [8.384673502857135, 49.21796780215553],
          [8.384673344212882, 49.21796846613799],
          [8.384673139744782, 49.217969121361484],
          [8.38384031843512, 49.22207476542962],
          [8.38384011884363, 49.22207674254869],
          [8.383840314135563, 49.22207872009707],
          [8.38384089659916, 49.222080619984624],
          [8.383841843233887, 49.222082367187895],
          [8.383843116658683, 49.222083892712675],
          [8.383844666588086, 49.22208513631848],
          [8.383846431817917, 49.22208604889737],
          [8.383848342642132, 49.22208659441307],
          [8.383850323605408, 49.22208675132407],
          [8.385315909290627, 49.22205673457108],
          [8.385317814887456, 49.222056511449715],
          [8.385319642800027, 49.222055928510564],
          [8.385321325741375, 49.222055007212106],
          [8.385322801761037, 49.2220537814681],
          [8.385324016525514, 49.222052296399184],
          [8.385324925318328, 49.22205060667198],
          [8.385325494686063, 49.22204877448672],
          [8.386154732123613, 49.21806492211936],
          [8.387543634757103, 49.214123610528496],
          [8.387543828162883, 49.21412281103869],
          [8.387544033380895, 49.21412212220747],
          [8.388308887466252, 49.21002546764895],
          [8.388308949695556, 49.210024765190866],
          [8.3883090471835, 49.21002408262959],
          [8.38830903351927, 49.21002381897032],
          [8.388309057017539, 49.21002355371669],
          [8.388308983099835, 49.210022846097935],
          [8.388308947116744, 49.210022151783214],
          [8.387690682952424, 49.20589228758873],
          [8.387690650588638, 49.20589215589064],
          [8.387690639765655, 49.20589202332492],
          [8.387690441347974, 49.2058913044267],
          [8.387690242734026, 49.2058904962061],
          [8.387690180231203, 49.20589035835989],
          [8.38769014075279, 49.205890215323436],
          [8.386175967204696, 49.201906376647116],
          [8.384926695823925, 49.19793906922829],
          [8.384089771617036, 49.193928993664706],
          [8.38354869716158, 49.18987036329847],
          [8.383548481947942, 49.18986944620992],
          [8.38354827225873, 49.189868524178245],
          [8.382208730914254, 49.18584749395486],
          [8.382208630533569, 49.185847273135835],
          [8.382208555125144, 49.18584700845027],
          [8.382208117370745, 49.1858461442721],
          [8.382207862739484, 49.185845584130206],
          [8.382207770358612, 49.18584545922973],
          [8.382207691834072, 49.185845304213146],
          [8.379798657337973, 49.182041361668944],
          [8.379798379504274, 49.182041002505],
          [8.379798148365143, 49.18204063195544],
          [8.377022485608618, 49.178416151064674],
          [8.37702217036259, 49.17841581697643],
          [8.377021878799924, 49.17841543154478],
          [8.373804805190058, 49.17494618449046],
          [8.373804790227116, 49.17494617115106],
          [8.373804778724953, 49.17494615606179],
          [8.370571752602489, 49.17148675321327],
          [8.368249767217813, 49.167757332972556],
          [8.36798668523123, 49.16375370246242],
          [8.370089181798265, 49.16002128265486],
          [8.372908655763535, 49.15637063149479],
          [8.37290870602859, 49.15637055059702],
          [8.37290877545918, 49.15637047329381],
          [8.372909548265495, 49.15636919508099],
          [8.37290972707384, 49.15636890730261],
          [8.372909734567449, 49.15636888693969],
          [8.372909746729107, 49.156368866824444],
          [8.37291040063991, 49.156367107134194],
          [8.374034654714377, 49.152171176907885],
          [8.374034722964472, 49.15217075768987],
          [8.374034838098298, 49.1521703557029],
          [8.374034882086622, 49.15216978030119],
          [8.374034976841934, 49.15216919827808],
          [8.374034959737266, 49.15216876456999],
          [8.37403499230138, 49.152168338605875],
          [8.374034920710072, 49.15216777499161],
          [8.374034897842368, 49.152167195155236],
          [8.374034792359403, 49.15216676453001],
          [8.374034737386678, 49.152166331748255],
          [8.373075526919855, 49.14802617280574],
          [8.373075452038398, 49.14802595401678],
          [8.37307493473497, 49.14802439480496],
          [8.371339612600943, 49.14408943543145],
          [8.370142931619139, 49.14012003806129],
          [8.369914442258885, 49.13604366468727],
          [8.369914388562652, 49.13604332660236],
          [8.369914379206843, 49.13604297201656],
          [8.369403603143219, 49.13199642102703],
          [8.369403590196123, 49.13199636386236],
          [8.369403588081278, 49.13199630698422],
          [8.369403414880605, 49.13199558980048],
          [8.369403174539196, 49.13199452863302],
          [8.369403139518676, 49.13199444959073],
          [8.36940311982818, 49.13199436805696],
          [8.368019564920473, 49.12804374271116],
          [8.368019421560863, 49.12804343243557],
          [8.368019311647144, 49.12804309305862],
          [8.36633282206384, 49.12412649887266],
          [8.36528283762676, 49.120140312603375],
          [8.36451720024171, 49.11612215814916],
          [8.363766511646219, 49.1121021424628],
          [8.363130438906033, 49.108068970410486],
          [8.363130375645023, 49.10806872439993],
          [8.363130353011597, 49.108068499360385],
          [8.362292078776987, 49.10402275940112],
          [8.36229181469153, 49.104021899911174],
          [8.362291646459743, 49.10402126749767],
          [8.360782901824662, 49.1000104210129],
          [8.360782618218707, 49.10000984908318],
          [8.360782278386505, 49.10000907583515],
          [8.358611205837402, 49.096111185300764],
          [8.358611131635262, 49.096111077720245],
          [8.358611080592123, 49.09611096694935],
          [8.358610682736773, 49.09611042689357],
          [8.358610121755474, 49.09610961356583],
          [8.358609984059791, 49.096109478497276],
          [8.35860987784339, 49.09610933431728],
          [8.355384236725607, 49.0925517132687],
          [8.355383718847285, 49.092551244915995],
          [8.355383135434126, 49.092550669943655],
          [8.351450691038211, 49.08935467667982],
          [8.347826819303387, 49.086075307603984],
          [8.344771218997124, 49.08248992516616],
          [8.34477073940835, 49.08248946172624],
          [8.344770277771804, 49.0824889607384],
          [8.341082429582247, 49.079187697227646],
          [8.341081917647726, 49.07918732764499],
          [8.341081376860435, 49.07918687463683],
          [8.336765011998871, 49.076256374420005],
          [8.33676451490115, 49.07625610259658],
          [8.336764034842746, 49.07625578939099],
          [8.331909353196393, 49.07371299575846],
          [8.327577948541084, 49.07084434117151],
          [8.323754179960202, 49.06768035883773],
          [8.320544733526106, 49.06423337029464],
          [8.318056727708722, 49.06052306673314],
          [8.318056543349298, 49.06052284183218],
          [8.318056407034154, 49.060522615990436],
          [8.315350972720992, 49.056934252740746],
          [8.315350678240707, 49.0569339367968],
          [8.315350396600927, 49.056933556436675],
          [8.312220401428407, 49.05348094800592],
          [8.309360322347363, 49.04990783295264],
          [8.307067583961564, 49.046161250555166],
          [8.305159640042664, 49.042317147760095],
          [8.303717407652103, 49.03838484125584],
          [8.3025936676233, 49.03440802218367],
          [8.30201380608047, 49.030381332710135],
          [8.301836898921108, 49.02632277714559],
          [8.3018368570258, 49.02632248768001],
          [8.301836856370686, 49.026322193782605],
          [8.301419695356557, 49.022249015686015],
          [8.301419614524299, 49.02224861806308],
          [8.301419585161762, 49.02224824055693],
          [8.300677296792369, 49.018177671300606],
          [8.300677069732364, 49.0181768702048],
          [8.300676895192394, 49.01817615486967],
          [8.299274511352545, 49.014178709207656],
          [8.299274229609614, 49.01417810827056],
          [8.299274006801921, 49.01417752224904],
          [8.297311165480695, 49.01027937587541],
          [8.297311094696854, 49.010279263286584],
          [8.297311048369291, 49.01027915046899],
          [8.297310693382878, 49.01027862495627],
          [8.297310158049555, 49.01027777345468],
          [8.297310013669248, 49.010277618725766],
          [8.297309905929806, 49.01027745923108],
          [8.294287638539302, 49.006662392233906],
          [8.294287626004321, 49.00666237984036],
          [8.294287616628438, 49.00666236611596],
          [8.291288391081975, 49.003099613742805],
          [8.288643854540876, 48.9994436737653],
          [8.286127748906718, 48.99568089140686],
          [8.286127326490107, 48.99568037901814],
          [8.286126609481425, 48.99567948270484],
          [8.282737952073218, 48.99219061513196],
          [8.282737664213633, 48.99219036954926],
          [8.282737413322234, 48.99219010029971],
          [8.282736967161302, 48.99218977487046],
          [8.282736529137907, 48.99218940117796],
          [8.282736186475352, 48.99218920543906],
          [8.282735876623343, 48.99218897943338],
          [8.27806972325891, 48.98942395204443],
          [8.278069217496748, 48.989423713540006],
          [8.2780687564567, 48.98942344822269],
          [8.272934790646538, 48.987094550708676],
          [8.268230034395879, 48.98448662383176],
          [8.263950573338759, 48.98153735091139],
          [8.263950329659245, 48.981537214057134],
          [8.263950118980619, 48.98153705561284],
          [8.259438255871922, 48.978775620580855],
          [8.259437768686519, 48.97877538718774],
          [8.259437291693644, 48.97877510080108],
          [8.254425970296301, 48.97641810965802],
          [8.254425790516667, 48.97641804478371],
          [8.254425642177242, 48.976417962478415],
          [8.249239430662174, 48.974202795291156],
          [8.244340441299244, 48.97175596468612],
          [8.2399490757894, 48.96885563521886],
          [8.239948686454587, 48.96885542763886],
          [8.239948333320212, 48.96885518976824],
          [8.235073004179407, 48.96621022074243],
          [8.23507289016958, 48.96621017250441],
          [8.235072790578212, 48.966210108175446],
          [8.235072108072915, 48.96620984159614],
          [8.235071223630458, 48.96620946738494],
          [8.235071064726197, 48.966209434076006],
          [8.235070920173378, 48.966209377615215],
          [8.22924963619791, 48.964587020806405],
          [8.22924922866768, 48.964586946689884],
          [8.229248865142274, 48.96458683850209],
          [8.223278864289528, 48.96342292509457],
          [8.223278805600822, 48.963422919196105],
          [8.223278755300305, 48.96342290447277],
          [8.217346826101403, 48.96233456899277],
          [8.217346766662002, 48.96233456367702],
          [8.217346715733736, 48.962334549382305],
          [8.211389929610633, 48.96131053605723],
          [8.205459904101838, 48.96023413493528],
          [8.199866969502631, 48.958602893550854],
          [8.195497438640956, 48.95579523670804],
          [8.1922871984308, 48.95235302840025],
          [8.190356654956183, 48.948488387101044],
          [8.18851579019595, 48.94459846594793],
          [8.1885155150953, 48.94459801034055],
          [8.188514863643459, 48.94459689636799],
          [8.185870161525813, 48.94092762347662],
          [8.185869684047514, 48.940927088235355],
          [8.185869210751092, 48.94092649128153],
          [8.182508422448398, 48.93747794391507],
          [8.18250838372419, 48.93747791103558],
          [8.182508353933372, 48.93747787429448],
          [8.179125055854483, 48.934073402907394],
          [8.175983397657191, 48.93058297799368],
          [8.172856276922651, 48.92706791155668],
          [8.172856187967936, 48.92706782843048],
          [8.172856114979465, 48.9270677338709],
          [8.169623460878302, 48.92360536178596],
          [8.169623128366627, 48.92360507385552],
          [8.169622783341735, 48.923604701662434],
          [8.165964560990655, 48.92036325516313],
          [8.165964174804952, 48.920362975115744],
          [8.165963854592025, 48.9203626843457],
          [8.161855085028002, 48.91734031420649],
          [8.157811122633891, 48.91426937798566],
          [8.154947690791522, 48.910677879378255],
          [8.152396164459898, 48.90697852104793],
          [8.152395285949796, 48.90697747783887],
          [8.152394955372076, 48.90697707972387],
          [8.148994221765683, 48.90362231828056],
          [8.14899399982837, 48.90362213748756],
          [8.148993825935587, 48.90362194841399],
          [8.145304335201933, 48.90035709966545],
          [8.14229572026813, 48.8968337741322],
          [8.140380742630859, 48.89293936257839],
          [8.140380422277246, 48.89293885122646],
          [8.14038013666179, 48.8929382998293],
          [8.137956658811488, 48.88923459043827],
          [8.137956401171223, 48.88923426672923],
          [8.137956193186257, 48.88923393756311],
          [8.135174867303938, 48.885647506457346],
          [8.135174688088156, 48.8856473178472],
          [8.1351745371746, 48.88564710294283],
          [8.132133869887657, 48.88212216005662],
          [8.129144030744284, 48.878569083668694],
          [8.127052000490664, 48.87476772967254],
          [8.125706903195615, 48.870789833134154],
          [8.125706557908455, 48.870789056699664],
          [8.125706339723738, 48.87078849557741],
          [8.123753504969187, 48.86695680349966],
          [8.123753266656843, 48.86695642856675],
          [8.123753068523701, 48.86695603341668],
          [8.121410016883868, 48.86321785804075],
          [8.119106110766232, 48.859465121659795],
          [8.117384856527096, 48.855601989146486],
          [8.11656446164066, 48.8516934318358],
          [8.116842865361672, 48.847694533798816],
          [8.116842858054385, 48.847694304889465],
          [8.116842886923264, 48.84769406666083],
          [8.116936067166886, 48.84359716561205],
          [8.116936057607026, 48.84359704693963],
          [8.116936069728554, 48.843596916415336],
          [8.11693593799055, 48.84359556206667],
          [8.116935901851289, 48.84359511344776],
          [8.116935890659905, 48.843595075478184],
          [8.116935886476185, 48.84359503246693],
          [8.11614806435885, 48.839536903721395],
          [8.116147949166546, 48.8395365107252],
          [8.11614788089531, 48.83953612614779],
          [8.115037866762986, 48.83555114173842],
          [8.115037128802054, 48.835549256306265],
          [8.115036026183596, 48.83554755816808],
          [8.115034604108798, 48.83554611693804],
          [8.11503292087478, 48.83554499169852],
          [8.11503104548472, 48.83554422857804],
          [8.115029054819122, 48.83554385886026],
          [8.115027030484143, 48.83554389770157],
        ],
      ],
    },
    pegel_id: 'Maxau m+PNP_km362',
    info_url: null,
    image_url:
      'https://upload.wikimedia.org/wikipedia/commons/5/5c/Pegelmaxau.jpg',
    is_selectable: true,
    is_pseudo: false,
  },
  selectedRoute: null,
  selectedDateTime: null,
  safetyMargin: +process.env.REACT_APP_SAFETY_MARGIN_DEFAULT,
};

export const routeSelectorReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_SELECTED_FROM: {
      return {
        ...state,
        selectedFrom: action.selected_from,
        selectedRoute: null,
      };
    }
    case SET_SELECTED_TO: {
      return {
        ...state,
        selectedTo: action.selected_to,
        selectedRoute: null,
      };
    }
    case SET_SELECTED_ROUTE: {
      return {
        ...state,
        selectedRoute: action.selected_route,
      };
    }
    case SET_SELECTED_DATE_TIME: {
      return {
        ...state,
        selectedDateTime: action.selected_date_time,
      };
    }
    case SWAP_SELECTED_POINT: {
      return {
        ...state,
        selectedFrom: state.selectedTo,
        selectedTo: state.selectedFrom,
        selectedRoute: null,
      };
    }
    case SET_SAFETY_MARGIN: {
      if (action.margin === '') {
        return { ...state, safetyMargin: '' };
      }

      return {
        ...state,
        safetyMargin: clamp(+action.margin.toFixed(2), 0, 1),
      };
    }
    default:
      return state;
  }
};

/**
 * Here we don't include selectedDateTime in the serializer.
 * It should not be persisted in the local storage to always
 * get the current date.
 */
export const serializeRouteState = (state) => {
  const { selectedDateTime, ...restOfState } = state;
  return restOfState;
};
